import './kentuckycastle/style';
import FormStructure from './kentuckycastle/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js